import { Box, Skeleton } from "@mui/material";

const CHART_BOX = {
    p: 2,
    height: 320,
};

export default function ChartSkeleton() {
    return (
        <Box sx={CHART_BOX}>
            <Skeleton variant="rectangular" height="100%" animation="wave" sx={{ borderRadius: 1 }} />
        </Box>
    );
}
